import { render } from "./applyCostWithoutAudit.vue?vue&type=template&id=b5450bf6"
import script from "./applyCostWithoutAudit.vue?vue&type=script&lang=js"
export * from "./applyCostWithoutAudit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Project\\VuePro\\ERP\\erp-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__